/* Virkarn – tema-JS. Ingen extern beroende. */
(() => {
  const cfg = window.theme || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  /* ---------- Toppmeddelande: rotera ---------- */
  const rotateAnnouncements = () => {
    const track = $('[data-announcement]');
    if (!track) return;
    const items = $$('.announcement__item', track);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 5000);
  };

  /* ---------- Varukorgspanel ---------- */
  const drawer = () => $('[data-cart-drawer]');
  const openDrawer = () => {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
  };
  const closeDrawer = () => {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };
  const setCount = (n) => {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.hidden = Number(n) === 0;
    });
  };
  const applyDrawerHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-content]', doc);
    const current = $('[data-cart-content]');
    if (!fresh || !current) return;
    current.innerHTML = fresh.innerHTML;
    current.dataset.itemCount = fresh.dataset.itemCount;
    setCount(fresh.dataset.itemCount);
  };
  const refreshDrawer = async () => {
    const res = await fetch(`${cfg.routes.cart}?sections=cart-drawer`);
    const data = await res.json();
    applyDrawerHtml(data['cart-drawer']);
  };
  const changeLine = async (line, quantity) => {
    const res = await fetch(cfg.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'cart-drawer' }),
    });
    const cart = await res.json();
    if ($('[data-cart-page]') || !drawer()) {
      window.location.reload();
    } else if (cart.sections) {
      applyDrawerHtml(cart.sections['cart-drawer']);
    } else {
      refreshDrawer();
    }
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer()) {
      e.preventDefault();
      refreshDrawer().finally(openDrawer);
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      closeDrawer();
      return;
    }
    const remove = e.target.closest('[data-remove-line]');
    if (remove) {
      changeLine(Number(remove.dataset.removeLine), 0);
      return;
    }
    const step = e.target.closest('[data-qty-step]');
    if (step) {
      const wrap = step.closest('[data-qty]');
      const input = $('input', wrap);
      const min = Number(input.min || 0);
      const next = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
      input.value = next;
      if (input.dataset.line) changeLine(Number(input.dataset.line), next);
      return;
    }
    const toggle = e.target.closest('[data-toggle]');
    if (toggle) {
      const target = document.getElementById(toggle.dataset.toggle);
      if (target) target.hidden = !target.hidden;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty__input[data-line]');
    if (input) changeLine(Number(input.dataset.line), Math.max(0, Number(input.value || 0)));
    const auto = e.target.closest('form[data-auto-submit]');
    if (auto && (e.target.matches('select') || e.target.matches('input[type=checkbox]'))) auto.submit();
  });

  /* ---------- Lägg i varukorg (AJAX när panel används) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || cfg.cartType !== 'drawer' || !drawer()) return;
    e.preventDefault();
    const btn = $('[data-add-to-cart]', form);
    const errorEl = $('[data-form-error]', form);
    if (errorEl) errorEl.hidden = true;
    btn.classList.add('is-loading');
    try {
      const body = new FormData(form);
      body.append('sections', 'cart-drawer');
      const res = await fetch(`${cfg.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      const data = await res.json();
      if (data.status && data.status !== 200 && !data.sections) {
        throw new Error(data.description || data.message || cfg.strings.error);
      }
      if (data.sections) applyDrawerHtml(data.sections['cart-drawer']);
      else await refreshDrawer();
      openDrawer();
    } catch (err) {
      if (errorEl) {
        errorEl.textContent = err.message || cfg.strings.error;
        errorEl.hidden = false;
      }
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------- Produktsida: varianter och galleri ---------- */
  const initProduct = (section) => {
    const variantsEl = $('[data-variants]', section);
    if (!variantsEl) return;
    const variants = JSON.parse(variantsEl.textContent);
    const gallery = $('[data-gallery]', section);
    const idInput = $('[data-variant-id]', section);
    const addBtn = $('[data-add-to-cart]', section);
    const priceWrap = $('[data-price-wrapper]', section);

    const showMedia = (id) => {
      if (!gallery || !id) return;
      $$('.gallery__item', gallery).forEach((el) => el.classList.toggle('is-active', el.dataset.mediaId === String(id)));
      $$('.gallery__thumb', gallery).forEach((el) => el.classList.toggle('is-active', el.dataset.thumb === String(id)));
    };

    gallery && gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb]');
      if (thumb) showMedia(thumb.dataset.thumb);
    });

    const picker = $('[data-variant-picker]', section);
    if (!picker) return;

    const update = () => {
      const chosen = $$('fieldset', picker).map((f) => {
        const checked = $('input:checked', f);
        return checked ? checked.value : null;
      });
      const variant = variants.find((v) => v.options.every((o, i) => o === chosen[i]));

      if (!variant) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.labelUnavailable;
        }
        return;
      }
      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = !variant.available;
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? addBtn.dataset.labelAdd : addBtn.dataset.labelSold;
      }
      if (priceWrap) {
        const cur = $('[data-price-current]', priceWrap);
        const cmp = $('[data-price-compare]', priceWrap);
        const sale = variant.onSale && variant.available;
        cur.textContent = variant.price;
        cur.classList.toggle('price__current--sale', sale);
        priceWrap.classList.toggle('price--sale', sale);
        if (cmp) {
          cmp.textContent = variant.compare;
          cmp.hidden = !sale;
        }
      }
      showMedia(variant.media);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };

    picker.addEventListener('change', update);
  };

  /* ---------- Liknande produkter (laddas efter sidan) ---------- */
  const initRecommendations = () => {
    $$('[data-recommendations]').forEach(async (el) => {
      if (!el.dataset.url || el.children.length) return;
      try {
        const res = await fetch(el.dataset.url);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      } catch (_) { /* tyst */ }
    });
  };

  const init = () => {
    rotateAnnouncements();
    $$('[data-product-section]').forEach(initProduct);
    initRecommendations();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Temaeditorn: initiera om när en sektion laddas om */
  document.addEventListener('shopify:section:load', (e) => {
    $$('[data-product-section]', e.target).forEach(initProduct);
    initRecommendations();
  });
})();
